/* eslint-disable react/prop-types */
import { ICellTextProps } from "ka-table/props";
import { TrendingDown, TrendingUp } from "lucide-react";
import React from "react";
import TruncatedTextTooltip from "../ui/truncate/TruncatedText";

const MetricCell: React.FC<ICellTextProps> = React.memo(
  ({
    column, ...props
  }) => {
    const rawValue = props.rowData[`${column.key}`];
    const displayFormat = (column as any).displayFormat;

    // Handle both structured {value, delta} objects and raw primitive values
    const isStructured = rawValue !== null && typeof rawValue === "object" && "value" in rawValue;
    const metricValue = isStructured ? (rawValue.value ?? 0) : (rawValue ?? 0);

    if (displayFormat === "percentage") {
      const numValue = Number(metricValue) || 0;
      const isPositive = numValue > 0;
      const isNegative = numValue < 0;
      const label = `${numValue > 0 ? "+" : ""}${Math.round(numValue)}%`;

      return (
        <span className="whitespace-nowrap w-full text-ellipsis overflow-hidden block">
          <span
            className={`inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium rounded-[5px] ${
              isPositive
                ? "bg-green-50 text-green-700"
                : isNegative
                  ? "bg-red-50 text-red-700"
                  : "bg-gray-100 text-gray-500"
            }`}
          >
            {isPositive && <TrendingUp className="h-3 w-3" />}
            {isNegative && <TrendingDown className="h-3 w-3" />}
            {label}
          </span>
        </span>
      );
    }

    return (
      <span className="whitespace-nowrap w-full text-ellipsis overflow-hidden block">
        <TruncatedTextTooltip size="sm" tooltipText={String(metricValue)} width={100}>
          <span className="text-sm text-gray-900">{metricValue}</span>
        </TruncatedTextTooltip>
      </span>
    );
  },
);

export default MetricCell;
